document.addEventListener("DOMContentLoaded", function() {


  const buttons = document.querySelectorAll('[data-grid]');
  const gridItems = document.querySelectorAll('.template-collection > main > div > div > div > div.product-grid-container > .collection ul#product-grid.grid--4-col-desktop > li.grid__item');

  buttons.forEach(btn => {
    btn.addEventListener('click', () => {
      // Quitar clase "active" a todos
      buttons.forEach(b => b.classList.remove('active'));

      // Agregar clase "active" al clicado
      btn.classList.add('active');

      // Obtener el valor del data-grid
      const gridValue = btn.getAttribute('data-grid');

      // Eliminar clases previas item-*
      gridItems.forEach(item => {
        item.className = item.className.replace(/\bitem-\S+/g, '').trim();
        // Agregar nueva clase
        item.classList.add(`item-${gridValue}`);
      });
    });
  });





    document.addEventListener("click", function (e) {
    const target = e.target.closest(".container-select-grid .item");   
      let anchor = target.dataset.grid
    if (target) {
    
      if (document.body.classList.contains("template-collection")) {
         console.log("create")
        document.cookie = `menu=${anchor};path=/`;       
      } 
    }
  });

  if (document.body.classList.contains("template-collection")){
    const menuCurrent = getCookie("menu");
    if (menuCurrent) {     
        buttons.forEach(b => b.classList.remove('active'));
        const section = document.querySelector(`.container-select-grid .items-${menuCurrent}`).classList.add("active")      
        gridItems.forEach(item => {
          item.className = item.className.replace(/\bitem-\S+/g, '').trim();
          
          item.classList.add(`item-${menuCurrent}`);
      });  
    }
  }




 const megamenu = document.querySelector(".wrapper--megamenu");
  if (megamenu) {
    megamenu.classList.remove("hide");
  }



  AOS.init();

  const isProductTemplate = document.querySelector('.template-product');
  if (isProductTemplate) {
   let currColorProduct = document.querySelector(".wrapper-swatch-color #show__color.active")
    
    if(currColorProduct){
      currColorProduct = currColorProduct.innerHTML
      document.querySelector("#curr-color-selected").innerHTML = currColorProduct          
    }
  } 

  let hAnnouncementbar = document.querySelector(".announcement-bar-section").offsetHeight;
  document.querySelector("#menu-drawer").style.top = `-${hAnnouncementbar}px`;
  document.querySelector("#account-drawer").style.top = `-${hAnnouncementbar}px`;

  let style = document.querySelector('#Details-menu-drawer-container summary').style;
  style.setProperty('--topDraw', `-${hAnnouncementbar}px`);

  window.onresize = function(event) {
    hAnnouncementbar = document.querySelector(".announcement-bar-section").offsetHeight;   
    document.querySelector("#menu-drawer").style.top = `-${hAnnouncementbar}px`;
    document.querySelector("#account-drawer").style.top = `-${hAnnouncementbar}px`;

    style = document.querySelector('#Details-menu-drawer-container summary').style;
    style.setProperty('--topDraw', `-${hAnnouncementbar}px`);
  };

  
  document.getElementById("simulate-close-drawer").addEventListener("click", (e) => {   
    document.querySelector("#Details-menu-drawer-container summary").click()
    document.querySelector("body").classList.remove("open--menu")  
    document.querySelector("html").classList.remove("kill-overflow") 
    //console.log("4")
  });
  document.getElementById("simulate-close-drawer-2").addEventListener("click", (e) => {  
    document.querySelector("#Details-account-drawer-container summary").click()
    document.querySelector("body").classList.remove("open--menu")  
    document.querySelector("html").classList.remove("kill-overflow") 
    //console.log("4")
  });

  document.querySelector("#Details-menu-drawer-container summary").addEventListener("click", (e) => {
    return
    hAnnouncementbar = document.querySelector(".announcement-bar-section").offsetHeight;   
    document.querySelector("#menu-drawer").style.top = `-${hAnnouncementbar}px`;

    style = document.querySelector('#Details-menu-drawer-container summary').style;
    style.setProperty('--topDraw', `-${hAnnouncementbar}px`);

    document.querySelector("body").classList.add("open--menu")
    document.querySelector("html").classList.add("kill-overflow") 
    //console.log(1)
  });

  /* ACTIVATE CART 
  document.querySelector(".header__icon--cart").addEventListener("click", (e) => {
 
    document.querySelector("body").classList.add("open--menu")
    document.querySelector("html").classList.add("kill-overflow") 
    console.log(2)
  });*/
  
  if(document.querySelector('body').classList.contains('template-product')){
  
    let el = document.querySelector(".template-product .product-form__submit")
    if(el){
      document.querySelector(".template-product .product-form__submit").addEventListener("click", (e) => {
        document.querySelector("body").classList.add("open--menu")
        document.querySelector("html").classList.add("kill-overflow") 
        //console.log(5)
      });  
    }
  }

  /*
  document.querySelector(".drawer__close").addEventListener("click", (e) => {
    document.querySelector("body").classList.remove("open--menu")
    document.querySelector("html").classList.remove("kill-overflow")
    console.log(7)
  });
 

  document.querySelector(".cart-drawer__overlay").addEventListener("click", (e) => {
    document.querySelector("html").classList.remove("kill-overflow")
    document.querySelector("body").classList.remove("open--menu")
    console.log(10)
  }); */

  /* VIDEO CUSTOM */
  document.querySelectorAll('.vd-home.is--video').forEach(function(element) {
    var videoElement = element.querySelector('video');
    var sourceDesktop = videoElement.getAttribute('srcdesk');
    var sourceMobile = videoElement.getAttribute('srcmob');
    var videoWidth = 608;

    if (window.innerWidth < 750) {
        videoWidth = 608; // Cambia esto al valor deseado para dispositivos móviles
        sourceDesktop = sourceMobile;
    }

    videoElement.setAttribute('width', videoWidth);

    var sourceElement = document.createElement('source');
    sourceElement.setAttribute('fill', '#fff');
    sourceElement.setAttribute('style', 'background-color: transparent;fill:#fff;');
    sourceElement.setAttribute('src', sourceDesktop);
    sourceElement.setAttribute('type', 'video/mp4');

    videoElement.appendChild(sourceElement);

    document.querySelectorAll('.vd-home a video').forEach(function(video) {
        video.classList.add('is-loaded');
    });
  });

  /* CLOSE TOP BAR */
  document.getElementById("close-announcement").addEventListener("click", (e) => {
    document.querySelector(".announcement-bar-section").remove()
  });

 /* for all dom elements on click
  document.onclick = function(event) {
    //console.log(event.target.id)
    if(event.target.id == "open_popup_from_drawer") { // check if it's a link     
      document.querySelector("#CartDrawer-Overlay").click()
      setTimeout(() => {
        checkCart()    
      }, 10);
    }else if(event.target.id == "CartDrawer-Overlay"){
      document.querySelector("body").classList.remove("open--menu")
      document.querySelector("html").classList.remove("kill-overflow")
      //console.log(12)
    }else if (event.target.id == "close-notification"){
      document.querySelector(".container-popup").classList.add("hide")
    }

    if( event.target.className == "header__icon header__icon--menu header__icon--summary link focus-inset"){
      document.querySelector("body").classList.remove("open--menu")
      document.querySelector("html").classList.remove("kill-overflow")
      //console.log(13)
    }
  }*/

if (document.body.classList.contains('template-index')) {
  document.querySelectorAll('[id^="shopify-section-"]').forEach(section => {
    const img1 = section.querySelector('.image-wrapper-1 img');
    const img2 = section.querySelector('.image-wrapper-2 img');
    const wrapper2 = section.querySelector('.image-wrapper-2');
    const wrapperTxt = section.querySelector('.wrapper_txt');

    if (img1 && wrapper2) {
      const imgHeight = img1.offsetHeight;
      window.addEventListener('scroll', () => {
        const scrollY = window.scrollY;
        if (scrollY < imgHeight) wrapper2.style.height = `${scrollY}px`;
      });
    }

    if (img2 && wrapperTxt && wrapper2) {
      const img2Height = img2.offsetHeight;
      const updateScroll = () => {
        const rect = section.getBoundingClientRect();
        if (rect.top <= 0 && rect.top * -1 < img2Height) {
          wrapper2.style.height = `${rect.top * -1}px`;
        } else if (rect.top > 0) {
          wrapper2.style.height = '0px';
        }
        requestAnimationFrame(updateScroll);
      };
      requestAnimationFrame(updateScroll);
    }
  });
}

  if(document.querySelector('body').classList.contains('forms-page') || document.querySelector('body').classList.contains('create-wholesale-account-page')){

    let currStep;
    document.querySelectorAll(".frm--btn.next-form").forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault()
        currStep = e.target.dataset.current

        let validRegex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;    
        let success = false

        /* VAR MODULE 1 */
        let nameMod1 = document.getElementById("name-mod-1")
        let lastNameMod1 = document.getElementById("last-name-mod-1")
        let addressMod1 = document.getElementById("address-mod-1")
        let cityMod1 = document.getElementById("city-mod-1")
        let stateMod1 = document.getElementById("state-mod-1")        
        let zipCodeMod1 = document.getElementById("zip-mode-1")
        let phoneMod1 = document.getElementById("phone-mod-1")
        let emailMod1 = document.getElementById("email-mod-1")

        /* VAR MODULE 2 */
        let accountingNameMod2 = document.getElementById("accounting-name-mod-2")
        let accountingPhoneMod2 = document.getElementById("accounting-phone-mod-2")
        let salesNameMod2 = document.getElementById("sales-name-mod-2")
        let salesPhoneMod2 = document.getElementById("sales-phone-mod-2")
        
        /* VAR MODULE 3 */    
        let companyMod3 = document.getElementById("company-mod-3")
        let websiteMod3 = document.getElementById("website-mod-3")
        let addressMod3 = document.getElementById("address-mod-3")
        let cityMod3 = document.getElementById("city-mod-3")
        let stateMod3 = document.getElementById("state-mod-3")
        let zipCodeMod3 = document.getElementById("zip-mode-3")
        let phoneMod3 = document.getElementById("phone-mod-3")
        let emailMod3 = document.getElementById("email-mod-3")
        let feinMod3 = document.getElementById("federal-employer-mod-3")
        let resellerNumberMod3 = document.getElementById("reseller-number-mod-3")

        let aboutCompanyMod3 = document.getElementById("about-company-mod-3")
        let companySalesMod3 = document.getElementById("company-sales-mod-3")
        let numberEmployeesMod3 = document.getElementById("employees-mod-3")
        let aboutColorfastMod3 = document.getElementById("about-color-fast-mod-3")
        let companyGoalsMod3 = document.getElementById("company-goals-mod-3")   
        let companyPhoneMod3 = document.getElementById("company-phone-mod-2")   
        
        let emailIsEmpty = document.getElementById("sales-email-mod-2")   

        let termsAcept = document.getElementById("accept-mod-3")
        let termsAceptColor = document.getElementById("accept-color-mod-3")
        let main_sales_contact_email = document.getElementById("main_sales_contact_email")
        let accounting_contact_name = document.getElementById("accounting_contact_name")
       

        /* VALID MODULE 3 */
        if(currStep == "3"){
          
          if(nameMod1.value == ""){        
            msg(nameMod1)
          }else if(lastNameMod1.value == ""){
            msg(lastNameMod1)
          }else if(addressMod1.value == ""){
            msg(addressMod1)
          }else if(cityMod1.value == ""  ){
            msg(cityMod1)
          }else if(stateMod1.value == ""){
            msg(stateMod1)
          }else if(zipCodeMod1.value == ""){     
            msg(zipCodeMod1)
          }else if(phoneMod1.value == ""){
            msg(phoneMod1)
          }else if(emailMod1.value == ""  || !emailMod1.value.match(validRegex)){
            msg(emailMod1)
          }/*else if(accountingNameMod2.value == ""){
            msg(accountingNameMod2)
          }else if(accountingPhoneMod2.value == ""){
            msg(accountingPhoneMod2)
          }else if(salesNameMod2.value == ""){
            msg(salesNameMod2)
          }else if(salesPhoneMod2.value == ""){
            msg(salesPhoneMod2)          
          }else if(companyMod3.value == ""){
             msg(companyMod3)
          }else if(websiteMod3.value == ""){
            msg(websiteMod3)
          }else if(addressMod3.value == ""){
            msg(addressMod3)
          }else if(cityMod3.value == ""){
            msg(cityMod3)
          }else if(stateMod3.value == ""){
            msg(stateMod3)
          }else if(zipCodeMod3.value == ""){          
            msg(zipCodeMod3)
          }else if(phoneMod3.value == ""){
            msg(phoneMod3)
          }else if(emailMod3.value == "" || !emailMod3.value.match(validRegex)){
            msg(emailMod3)            
          }*/else if(feinMod3.value == ""){
            msg(feinMod3)
          }else if(resellerNumberMod3.value == ""){
            msg(resellerNumberMod3)   
          }else if(aboutCompanyMod3.value == ""){
             msg(aboutCompanyMod3) 
          }else if(numberEmployeesMod3.value == ""){
             msg(numberEmployeesMod3) 
          }else if(aboutColorfastMod3.value == ""){
             msg(aboutColorfastMod3) 
          }else if(companyGoalsMod3.value == ""){
             msg(companyGoalsMod3) 
          }else if(!termsAcept.checked){               
            msg(termsAcept)
          }else if(!termsAceptColor.checked){        
            msg(termsAceptColor)        
          }else{  

           if(companyMod3.value == ""){
              companyMod3.value = nameMod1.value
            }

            if(salesNameMod2.value == ""){
              salesNameMod2.value = nameMod1.value
            }

            if(companyPhoneMod3.value == ""){
              companyPhoneMod3.value =  phoneMod1.value
            }

            if(companyPhoneMod3.value == ""){
              companyPhoneMod3.value =  phoneMod1.value
            }

            if(emailIsEmpty.value == ""){
              emailIsEmpty.value = emailMod1.value
            }
           
            if(accountingPhoneMod2.value == ""){
              accountingPhoneMod2.value = phoneMod1.value
            }

            if(salesPhoneMod2.value == ""){
              salesPhoneMod2.value = phoneMod1.value
            }

            if(main_sales_contact_email.value == ""){
               main_sales_contact_email.value = emailMod1.value
            }
            if (accounting_contact_name.value != "") {
              accounting_contact_name.value = nameMod1.value
            }

            document.querySelector("#send-frm-progress span").innerText = "Sending ...";
            let formData = new FormData();

            document.querySelectorAll("#form-data-wholesale input, #form-data-wholesale textarea, #form-data-wholesale select").forEach(function(el, index) {                      
              if(el.name != "copy" & el.name != "acept_terms_and_conditions" & el.name != "i_consent_to_colorfast_contacting" & el.name != "your_reseller"){          
                  formData.append(el.name, el.value);              
              }
              if(el.name == "acept_terms_and_conditions" || el.name == "i_consent_to_colorfast_contacting"){
                if(el.checked){
                  formData.append(el.name, 1); 
                }else{
                  formData.append(el.name, 0); 
                }              
              }          
            });

          // Use fetch API to send the data
            fetch("https://colorfast.portaldev.xyz/api/v1/saveform", {
                method: 'POST',
                body: formData,
                //body: serializedData, // FormData will be sent as multipart/form-data
                redirect: "follow"
            })
            .then(response => {
                if(response.ok) {
                    return response.json(); // or response.text() if the server returns plain text
                }
                throw new Error('Network response was not ok.');
            })
            .then(data => {
                success = true
                //console.log('File and text uploaded successfully:', data);            
                document.querySelector("#send-frm-progress span").innerText = "Submit"
                document.querySelector("body").classList.add("kill-overflow")
                document.querySelector("#request-send").classList.add("open")
              //console.log(23)
                msg("", success)       
            })
            .catch(error => {
                console.error('Error during upload:', error);
            });
            
          }       
        }
      }); /* END CLICK SUBMIT */
    });

    /* CLOSE POPUP SUCCESS REQUEST */
    document.querySelectorAll(".close--popup-success").forEach((item) => {
      item.addEventListener("click", (e) => {
        document.querySelector("body").classList.remove("kill-overflow")
        document.querySelector("#request-send").classList.remove("open")  
        document.getElementById("form-data-wholesale").reset()  
        location.reload();    
      });
    })

    if(btnPrev){
      btnPrev.addEventListener("click", () => {
        lessStep()
      });      
    }

    document.querySelector("#copy-fields_1").addEventListener("click", (e) => {

      console.log("click")

      let mainName = document.getElementById("name-mod-1").value
      
      let accountingNameMod2 = document.getElementById("phone-mod-1").value
      let emailMod1 = document.getElementById("email-mod-1").value
      
      document.getElementById("accounting-phone-mod-2").value = accountingNameMod2
      document.getElementById("sales-phone-mod-2").value = accountingNameMod2

      document.getElementById("accounting-name-mod-2").value = emailMod1
      document.getElementById("main_sales_contact_email").value = emailMod1

      document.getElementById("accounting_contact_name").value = mainName
      document.getElementById("sales-name-mod-2").value = mainName


      

    });

    document.querySelector("#copy-fields").addEventListener("click", (e) => {
      
      let accountingAddress = document.getElementById("address-mod-1").value
      let accountingCity = document.getElementById("city-mod-1").value
      let accountingState = document.getElementById("state-mod-1").value

      let accountingZipcode = document.getElementById("zip-mode-1").value
      let accountingPhone = document.getElementById("phone-mod-1").value
      let accountingEmail = document.getElementById("email-mod-1").value

      document.getElementById("address-mod-3").value = accountingAddress
      document.getElementById("city-mod-3").value = accountingCity
      document.getElementById("state-mod-3").value = accountingState

      document.getElementById("zip-mode-3").value = accountingZipcode
      document.getElementById("company-phone-mod-2").value = accountingPhone
      document.getElementById("sales-email-mod-2").value = accountingEmail


    });

    /* OPEN POPUP TERMS */
    document.getElementById("terms-popup").addEventListener("click", (e) => {
      e.preventDefault()
      document.querySelector("body").classList.add("kill-overflow")
      document.querySelector("#terms-wholesale").classList.add("open")
    });

    document.querySelectorAll(".close--popup-terms").forEach((item) => {
      item.addEventListener("click", (e) => {
        document.querySelector("body").classList.remove("kill-overflow")
        document.querySelector("#terms-wholesale").classList.remove("open")      
      });
    });
}


  let netx_thumb = document.getElementById("next--thumb")
  if(netx_thumb){
      netx_thumb.addEventListener("click", function(event) {
        event.preventDefault(); // Evita el comportamiento predeterminado
    
        const thumbnails = document.querySelectorAll("ul.thumbnail-list li");
        let found = false;
    
        thumbnails.forEach((li, index) => {
            const button = li.querySelector("button[aria-current='true']");
            
            if (button && !found) {
                found = true; // Marca que encontramos el actual
    
                let nextLi = thumbnails[index + 1] || thumbnails[0]; // Si no hay siguiente, vuelve al primero
                const nextButton = nextLi.querySelector("button");
    
                if (nextButton) {
                    nextButton.click(); // Hace clic en el botón del siguiente o del primero si no hay más
                }
            }
        });
    });    
  }


  console.log("load")
  
  document.querySelectorAll('.container-acordeon-price > .accordeon--price, .container-tabs .header-tabs, .color_collapsible .legent-custom, .quantity__label.form__label').forEach(el => {
    el.addEventListener('click', function () {
      console.log("click")
      this.parentElement.classList.toggle('open');
    });
  });


});/* END ONLOAD */

let progress = document.querySelector(".progress span");
let steps = document.querySelectorAll(".step");
let btnNext = document.querySelector(".frm-next");
let btnPrev = document.querySelector(".frm-prev");
let countSteps = steps.length;
let step = 1;


const msg = (el, success) => {
  let anchor = document.getElementById("view-msg")
  if(success){
    anchor.style.color = "#008060"
    anchor.innerHTML = `Sent successfully`
    setTimeout(() => {
      anchor.innerHTML = ``
     
    }, 3500);

  }else{
    el.focus()
    anchor.style.color = "red"
    anchor.innerHTML = `${el.dataset.name} field is empty`
    setTimeout(() => {
      anchor.innerHTML = ``
    }, 3000);
  }
}

const moreStep = () => { 
  let widthProgress = (step / (countSteps - 1)) * 100;
  btnPrev.classList.remove("disabled");
  btnPrev.classList.remove("hide");
  btnPrev.removeAttribute("disabled");

  if (step + 1 <= countSteps) {
    step++;
    // add class active on step
    let newStep = document.querySelector(`[data-step="${step}"]`);    
    progress.style.width = `${widthProgress}%`;
    newStep.classList.add("active");

    document.querySelectorAll('.wrapper-form .module').forEach(function(el) {
      el.classList.remove("active")
    });
    document.querySelector(`.module--${newStep.dataset.step}`).classList.add("active") 
    document.querySelector(`.frm-next`).dataset.current = newStep.dataset.step
  }
  if (step === countSteps) {
    btnNext.classList.add("disabled");
    btnNext.classList.add("hide");
    document.getElementById("send-frm-progress").classList.remove("hide")
    btnNext.setAttribute("disabled", "disabled");
  }
}

const lessStep = () => {
  btnNext.classList.remove("disabled");
  btnNext.classList.remove("hide");
  btnNext.removeAttribute("disabled");
  document.getElementById("send-frm-progress").classList.add("hide")
  if (step > 1) {
    let newStep = document.querySelector(`[data-step="${step}"]`);
    newStep.classList.remove("active");
    step--;
    let widthProgress = ((step - 1) / (countSteps - 1)) * 100;
    progress.style.width = `${widthProgress}%`; 
   
    document.querySelectorAll('.wrapper-form .module').forEach(function(el) {
      el.classList.remove("active")
    });
    document.querySelector(`.module--${step}`).classList.add("active") 
    document.querySelector(`.frm-next`).dataset.current = step
  }
  if (step === 1) {
    btnPrev.classList.add("disabled");
    btnPrev.classList.add("hide");
    btnPrev.setAttribute("disabled", "disabled");
  }
}




function updateTotalAndQty(qtyInput, totalQty, totalMoney, button) {
  //console.log("ready")
  var quantity = 0;
  var totalPriceValue = 0;

  qtyInput.forEach(function(input) {
    var variantQty = parseInt(input.value, 10);
    var variantPrice = parseFloat(input.dataset.price);
    var maxQty = parseInt(input.dataset.stock); // Obtener el máximo de stock

    // Verificar si la cantidad agregada excede el stock disponible
    if (variantQty > maxQty) {
      // Si la cantidad es mayor, establecerla como el máximo disponible
      input.value = maxQty;
      variantQty = maxQty; // Actualizar la cantidad con el máximo disponible
    }

    quantity += variantQty;
    totalPriceValue += variantQty * variantPrice;

  });


  if(quantity >= 0){      
    totalQty.innerText = quantity;            
    if(quantity < 100){   
      totalMoney.innerText = totalPriceValue.toFixed(2);
    }
    if(quantity > 99 & quantity < 300){
      let numeroOriginal = totalPriceValue.toFixed(2);
      let nuevePorCiento = numeroOriginal * 0.09;
      let resultado = numeroOriginal - nuevePorCiento;
      const numero = resultado
      const formatoMoneda = numero.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      totalMoney.innerText = formatoMoneda        

      
    }
    if(quantity > 299 & quantity < 1000){
      let numeroOriginal = totalPriceValue.toFixed(2);
      let nuevePorCiento = numeroOriginal * 0.18;
      let resultado = numeroOriginal - nuevePorCiento;
      const numero = resultado
      const formatoMoneda = numero.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      totalMoney.innerText = formatoMoneda     
    }
    if(quantity > 999){
      let numeroOriginal = totalPriceValue.toFixed(2);
      let nuevePorCiento = numeroOriginal * 0.26;
      let resultado = numeroOriginal - nuevePorCiento;
      const numero = resultado
      const formatoMoneda = numero.toLocaleString('en-US', { style: 'currency', currency: 'USD' });
      totalMoney.innerText = formatoMoneda          
    }
    
  }
  //totalPrice.innerText = "$" + (totalPriceValue.toFixed(2));
  if(parseInt(totalQty.innerText) > 0) {
    button.classList.remove('disabled');
  } else {
    button.classList.add('disabled');
  }

}


function formatCurrency(amount) {
  //console.log(amount)
  // Dividir el número por 100 para obtener el valor correcto en términos de dólares y centavos
  const dividedAmount = amount / 100;
  
  // Formatear el número como moneda USD
  return new Intl.NumberFormat('en-US', {
    style: 'decimal',
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  }).format(dividedAmount);
}





// Define el intervalo y la función a ejecutar repetidamente
let intervalId = setInterval(function() {
    // Verifica si el elemento con el ID especificado existe en el DOM
    let element = document.getElementById('wpd_product_quick_view_product_vd_table_wrapper');
    
    // Si el elemento existe, detén el intervalo
    if (element) {
        clearInterval(intervalId);
        console.log('Elemento encontrado, intervalo detenido.');
        
      let a = document.querySelector(".Wpd_disc_head").classList.add("hide")
      let b =  document.querySelectorAll(".Wpd_Discount")
      console.log(b)
      b.forEach(function(element) {
        element.classList.add("hide")
      });
    }
}, 1000); // El intervalo se ejecutará cada 1000 milisegundos (1 segundo)



/*
let intervalPrice = setInterval(function() {  
    let element = document.querySelector('.wpd-ext-compare-at-price');
        console.log(element)
    
    if (element) {
        clearInterval(intervalPrice);
        console.log('Elemento encontrado, intervalo detenido.');

      let a = document.querySelectorAll(".price__container")
      let b =  document.querySelectorAll(".wpd-ext-compare-at-price")
       a.forEach(function(element) {
        element.classList.add("active")
      });
      
      b.forEach(function(element) {
        element.classList.add("hide")
      });
    }
  
}, 1000); */

















let delete_cookie = (name) => {  
  document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
};

let getCookie = (cname) => {
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(';');
  for(var i = 0; i <ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

let setCookie = (name, value, hours) => {
  let d = new Date();
  d.setTime(d.getTime() + (hours * 60 * 60 * 1000)); // 5 horas en milisegundos
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
};